import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'baseline',
    '& > *:first-of-type': {
      display: 'flex',
      alignItems: 'baseline',
      flex: 1,
      '&:after': {
        content: '""',
        flex: 1,
        opacity: 0.4,
        margin: theme.spacing(0, 0.5),
        borderBottom: `1px dotted ${theme.palette.primary.main}`,
      },
    },
  },
}));

function LeaderMenuItem({ children }) {
  const { classes } = useStyles();
  const [first, second] = React.Children.toArray(children);
  return (
    <div className={classes.root}>
      <div>{first}</div>
      {second && <div>{second}</div>}
    </div>
  );
}

LeaderMenuItem.propTypes = {
  children: PropTypes.node.isRequired,
};

export default memo(LeaderMenuItem);
